module.exports = __webpack_public_path__ + "img/pdf.a3e573a0.jpg";